export default {
  path: '/employee',
  component: () => import('@/views/employee/employee-router.vue'),
  children: [
    {
      path: '',
      name: 'Employee',
      component: () => import('@/views/employee/pages/Employee.vue'),
      meta: {
        name: 'พนักงาน',
        icon: '/icons/users.svg',
        auth: true
      }
    },
    {
      path: 'employee-create',
      name: 'EmployeeCreate',
      component: () => import('@/views/employee/pages/EmployeeCreate.vue'),
      meta: {
        name: 'พนักงาน',
        icon: '/icons/users.svg',
        auth: true
      }
    },
    {
      path: 'employee-edit/:id',
      name: 'EmployeeEdit',
      component: () => import('@/views/employee/pages/EmployeeEdit.vue'),
      meta: {
        name: 'พนักงาน',
        icon: '/icons/users.svg',
        auth: true
      }
    }
  ]
}
